module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-8"
  }, [_c('div', {
    staticClass: "card card-default widget animated"
  }, [_c('div', {
    staticClass: "card-heading"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isEditing),
      expression: "!isEditing"
    }],
    staticClass: "mobileDeviceViewing col-md-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "font-size": "35px"
    }
  }, [_vm._v(_vm._s(_vm.workflow.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.workflow.description))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.workflow.active == true ? 'Active' : 'Inactive'))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.workflow.ranger),
      expression: "!workflow.ranger"
    }]
  }, [_vm._v(_vm._s(_vm.workflow.critical == false ? 'Non Critical' : 'Critical'))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.workflow.ranger),
      expression: "!workflow.ranger"
    }]
  }, [_vm._v(_vm._s(_vm.workflow.endtimebased == false ? 'Start Time Based' : 'End Time Based'))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.workflow.ranger),
      expression: "!workflow.ranger"
    }]
  }, [_vm._v("Schedule: " + _vm._s(_vm.workflow.schedule) + " Minutes")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.workflow.ranger),
      expression: "!workflow.ranger"
    }]
  }, [_vm._v("Warn Before: " + _vm._s(_vm.workflow.warnBefore) + " Minutes")]), _vm._v(" "), _c('p', [_vm._v("Last Completed: " + _vm._s(_vm.filteredData.lastcompleted))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.workflow.ranger),
      expression: "!workflow.ranger"
    }]
  }, [_vm._v("Next Due: " + _vm._s(_vm.filteredData.nextdue))]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.org['curOrg']['role'] == '1' || _vm.org['curOrg']['role'] == '2' || _vm.org['curOrg']['role'] == 99) ? _c('button', {
    staticClass: "btn  btn-default form-group",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.edit
    }
  }, [_vm._v("Edit")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEditing && !_vm.workflow.ranger),
      expression: "isEditing && !workflow.ranger"
    }],
    staticClass: "mobileDeviceEditing col-md-5"
  }, [_c('active-form-checkbox', {
    attrs: {
      "label": "Active",
      "name": "active"
    },
    model: {
      value: (_vm.workflowEdit.active),
      callback: function($$v) {
        _vm.$set(_vm.workflowEdit, "active", $$v)
      },
      expression: "workflowEdit.active"
    }
  }), _vm._v(" "), _c('critical-form-checkbox', {
    attrs: {
      "label": "Critical",
      "name": "critical"
    },
    model: {
      value: (_vm.workflowEdit.critical),
      callback: function($$v) {
        _vm.$set(_vm.workflowEdit, "critical", $$v)
      },
      expression: "workflowEdit.critical"
    }
  }), _vm._v(" "), _c('endtimebased-form-checkbox', {
    attrs: {
      "label": "End Time Based",
      "name": "endtimebased"
    },
    model: {
      value: (_vm.workflowEdit.endtimebased),
      callback: function($$v) {
        _vm.$set(_vm.workflowEdit, "endtimebased", $$v)
      },
      expression: "workflowEdit.endtimebased"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('form-text', {
    ref: "name",
    attrs: {
      "styler": "font-size:35px",
      "label": "Name",
      "name": "name",
      "validation": "required"
    },
    model: {
      value: (_vm.workflowEdit.name),
      callback: function($$v) {
        _vm.$set(_vm.workflowEdit, "name", $$v)
      },
      expression: "workflowEdit.name"
    }
  }), _vm._v(" "), _c('form-textarea', {
    attrs: {
      "label": "Description",
      "name": "description"
    },
    model: {
      value: (_vm.workflowEdit.description),
      callback: function($$v) {
        _vm.$set(_vm.workflowEdit, "description", $$v)
      },
      expression: "workflowEdit.description"
    }
  }), _vm._v(" "), _c('form-textnumber', {
    ref: "schedule",
    attrs: {
      "label": "Schedule",
      "name": "schedule",
      "validation": "required"
    },
    model: {
      value: (_vm.workflowEdit.schedule),
      callback: function($$v) {
        _vm.$set(_vm.workflowEdit, "schedule", $$v)
      },
      expression: "workflowEdit.schedule"
    }
  }), _vm._v(" "), _c('form-textnumber', {
    ref: "warnbefore",
    attrs: {
      "label": "Warn Before",
      "name": "warnbefore",
      "validation": "numeric"
    },
    model: {
      value: (_vm.workflowEdit.warnBefore),
      callback: function($$v) {
        _vm.$set(_vm.workflowEdit, "warnBefore", $$v)
      },
      expression: "workflowEdit.warnBefore"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn  btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancelEdit
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn  btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.submitEdit
    }
  }, [_vm._v("Submit")])])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEditing && _vm.workflow.ranger),
      expression: "isEditing && workflow.ranger"
    }],
    staticClass: "mobileDeviceEditing col-md-5"
  }, [_c('active-form-checkbox', {
    attrs: {
      "label": "Active",
      "name": "active"
    },
    model: {
      value: (_vm.workflowEdit.active),
      callback: function($$v) {
        _vm.$set(_vm.workflowEdit, "active", $$v)
      },
      expression: "workflowEdit.active"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "font-size": "35px"
    }
  }, [_vm._v(_vm._s(_vm.workflow.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.workflow.description))]), _vm._v(" "), _c('p', [_vm._v("Last Completed: " + _vm._s(_vm.filteredData.lastcompleted))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn  btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancelEdit
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn  btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.submitEdit
    }
  }, [_vm._v("Submit")])])])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.workflow.ranger),
      expression: "!workflow.ranger"
    }],
    staticClass: "col-md-5 offset-md-1"
  }, [_c('h5', [_vm._v("Tasks")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEditing),
      expression: "isEditing"
    }]
  }, [_vm._v("* Tasks cannot be edited after creation.")]), _vm._v(" "), (_vm.org['curOrg']['role'] == 99) ? _c('div', [(!_vm.tasksJsonView) ? _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.tasksJsonView = true
      }
    }
  }, [_vm._v("JSON View")]) : _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.tasksJsonView = false
      }
    }
  }, [_vm._v("Normal View")])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.tasks.length - 1) + " Tasks")]), _vm._v(" "), (!_vm.tasksJsonView) ? _c('div', _vm._l((_vm.tasks), function(task) {
    return _c('div', {
      staticClass: "list-group"
    }, _vm._l((task), function(element) {
      return _c('div', {
        staticClass: "list-group-item"
      }, [(element.name == 'Location Tag') ? _c('div', [_c('div', {
        staticClass: "d-flex w-100 justify-content-between"
      }, [_c('p', {
        staticStyle: {
          "font-size": "15px"
        }
      }, [_vm._v(_vm._s(element.name))])]), _vm._v(" "), _c('small', [_vm._v("Speak Text: " + _vm._s(element.speak))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', {}, [_vm._v("Tag Name: " + _vm._s(element.description))])]) : (element.name == 'Input') ? _c('div', [_c('div', {
        staticClass: "d-flex w-100 justify-content-between"
      }, [_c('p', {
        staticStyle: {
          "font-size": "15px"
        }
      }, [_vm._v(_vm._s(element.name))])]), _vm._v(" "), _c('small', [_vm._v("Type: " + _vm._s(_vm.inputTypes.find(function(inputType) {
        return inputType['.key'] == element.type
      })['name']))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', {}, [_vm._v("Name: " + _vm._s(element.description))])]) : (element.name == 'Temperature') ? _c('div', [_c('div', {
        staticClass: "d-flex w-100 justify-content-between"
      }, [_c('p', {
        staticStyle: {
          "font-size": "15px"
        }
      }, [_vm._v(_vm._s(element.name))])]), _vm._v(" "), _c('small', {}, [_vm._v("Name: " + _vm._s(element.description))])]) : _vm._e()])
    }), 0)
  }), 0) : _c('div', [_c('pre', [_vm._v(_vm._s(_vm._f("pretty")(_vm.tasks)))])])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5eff7c9c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/operations/Workflows/WorkflowDetail.vue
// module id = 632
// module chunks = 1